import React, { useState, useEffect, useMemo } from "react";
import { useAPI } from "app/hooks/useApi";
import { useSmartNavigation } from "app/utils/navigationHelper";
import { 
  Card, 
  CardContent, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Box,
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
  Button,
  CircularProgress,
  Pagination,
  Stack,
  Autocomplete,
  IconButton,
  Alert,
  Snackbar
} from "@mui/material";
import { alpha } from '@mui/material/styles';
import { AccessTime, Refresh, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import Div from "@jumbo/shared/Div";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import { mapApiError } from "app/utils/errorMessages";

const TIPOS_COLIDENCIA = [
  { value: 'APR', label: 'Apresentação' },
  { value: 'SUF', label: 'Sufixo' },
  { value: 'PRE', label: 'Prefixo' },
  { value: 'RAD', label: 'Radical' }
];

const PatentesColidencias = () => {
  // Estado para input da barra de busca de RPI
  const [rpiInput, setRpiInput] = useState("");
  // Função para buscar opções de RPI conforme digitação
  const fetchRpiOptions = async (inputValue) => {
    try {
      // Buscar RPIs que contenham o texto digitado, limitado às últimas 8
      const response = await makeRequest(`/rpis/all?rpiNumber=${inputValue}`, "GET");
      if (response.status === 200 && response.data) {

        setRpiOptions(response.data);
      } else {
        setRpiOptions([]);
      }
    } catch (err) {

      setRpiOptions([]);
  setSnackbar({ open: true, severity: 'error', message: mapApiError(err) });
    }
  };
  // Busca de RPI só ao pressionar Enter
  const handleRpiInputKeyDown = (event) => {
    if (event.key === 'Enter' && rpiInput.length > 1) {
      fetchRpiOptions(rpiInput);
    }
  };
  const { makeRequest, loading } = useAPI();
  const { navigateToProcesso } = useSmartNavigation();
  const [results, setResults] = useState([]);
  const [rpiOptions, setRpiOptions] = useState([]);
  const [niveisOptions, setNiveisOptions] = useState([]);
  const [responsaveisOptions, setResponsaveisOptions] = useState([]);
  const [envolvidosOptions, setEnvolvidosOptions] = useState([]);
  
  // Estados para seleção e atualização
  const [selectedColidencias, setSelectedColidencias] = useState(new Set());
  const [pendingSelections, setPendingSelections] = useState(new Set()); // Seleções pendentes de confirmação
  const [confirmedSelections, setConfirmedSelections] = useState(new Set()); // Seleções já confirmadas no backend
  const [isUpdating, setIsUpdating] = useState(false);
  const [updatingItems, setUpdatingItems] = useState(new Set());
  const [somentesSelecionados, setSomentesSelecionados] = useState(false);
  const [loadingSelections, setLoadingSelections] = useState(new Set());
  const [loadingConfirmacao, setLoadingConfirmacao] = useState(false);
  
  const [pagination, setPagination] = useState({
    page: 0,
    perPage: 30,
    count: 0,
    sortBy: "marca_nivel",
    sortOrder: "desc"
  });
  
  const [shouldSearch, setShouldSearch] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  
  useEffect(() => {
    // Reexecutar busca quando página ou perPage mudar, se shouldSearch estiver ativo
    if (shouldSearch) {
      handleSubmit();
      setShouldSearch(false);
    }
  }, [pagination.page, pagination.perPage, shouldSearch]);

  useEffect(() => {
    const fetchRPIs = async () => {
      try {
        // Buscar apenas as últimas 8 RPIs ordenadas por número (maior = mais recente)
        // Isso alinha com o sistema de colidências que verifica apenas as últimas revistas
        const response = await makeRequest("/rpis/latest", "GET");
        if (response.status === 200 && response.data) {
          setRpiOptions(response.data);
          
          // Não selecionar automaticamente nenhuma RPI - deixar usuário escolher

        }
      } catch (error) {

        setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
      }
    };

    const fetchDropdownOptions = async () => {
      try {
        const niveisResponse = await makeRequest("/colidencias/opcoes/niveis", "GET");
        if (niveisResponse.status === 200 && niveisResponse.data) {
          setNiveisOptions(niveisResponse.data);
        }
        const responsaveisResponse = await makeRequest("/colidencias/opcoes/responsaveis?role=operador", "GET");
        if (responsaveisResponse.status === 200 && responsaveisResponse.data) {
          setResponsaveisOptions(responsaveisResponse.data);
        }
      } catch (error) {

        setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
      }
    };
    
    const fetchEnvolvidos = async () => {
      try {
        const response = await makeRequest("/envolvidos?page=1&perPage=1000", "GET");
        if (response.status === 200 && response.data && Array.isArray(response.data.envolvidos)) {
          setEnvolvidosOptions(response.data.envolvidos);
        }
      } catch (error) {

        setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
      }
    };

    const loadSelectedColidencias = async () => {
      try {
        const response = await makeRequest("/colidencias/selecionadas", "GET");
        if (response.status === 200 && response.data && response.data.data) {
          const selectedIds = new Set(
            response.data.data.map(item => 
              `${item.processo_base.numero}-${item.processo_colidente.numero}`
            )
          );
          setConfirmedSelections(selectedIds);
          setSelectedColidencias(selectedIds);

        }
      } catch (error) {

        setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
      }
    };

    fetchRPIs();
    fetchDropdownOptions();
    fetchEnvolvidos();
    loadSelectedColidencias();
  }, []);  const initialFormState = {
    ordem: "marca_nivel",
    rpi: "",  
    tipo: "",
    processo: "",
    envolvido: [],
    grupoEnvolvido: "",
    nivelDe: "",
    nivelAte: "",
    marca: "",
    responsavel: "",
    exata: false,
    radical: "",
    somentesSelecionados: false
  };

  const [formState, setFormState] = React.useState(initialFormState);
  const [envolvidosBusca, setEnvolvidosBusca] = useState([{ id: '', value: null }]);
  const [responsaveisBusca, setResponsaveisBusca] = useState([{ id: '', value: null }]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'exata' || name === 'somentesSelecionados') {
      setFormState(prev => ({
        ...prev,
        [name]: e.target.checked
      }));
    } else {
      setFormState(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };  

  // Função para adicionar novo campo de envolvido
  const handleAddEnvolvido = () => {
    setEnvolvidosBusca(prev => [...prev, { id: '', value: null }]);
  };

  // Função para remover campo de envolvido
  const handleRemoveEnvolvido = (idx) => {
    setEnvolvidosBusca(prev => prev.filter((_, i) => i !== idx));
  };

  // Função para atualizar valor de um campo de envolvido
  const handleChangeEnvolvido = (idx, newValue) => {
    setEnvolvidosBusca(prev => prev.map((item, i) => i === idx ? { ...item, value: newValue } : item));
  };

  // Função para adicionar novo campo de responsável
  const handleAddResponsavel = () => {
    setResponsaveisBusca(prev => [...prev, { id: '', value: null }]);
  };

  // Função para remover campo de responsável
  const handleRemoveResponsavel = (idx) => {
    setResponsaveisBusca(prev => prev.filter((_, i) => i !== idx));
  };

  // Função para atualizar valor de um campo de responsável
  const handleChangeResponsavel = (idx, newValue) => {
    setResponsaveisBusca(prev => prev.map((item, i) => i === idx ? { ...item, value: newValue } : item));
  };

  const handleSubmit = async () => {
    try {
      // Permitir busca sem critérios para exibir todas as colidências
      const envolvidoIds = envolvidosBusca.map(e => e.value?.id).filter(Boolean);
      const responsavelIds = responsaveisBusca.map(e => e.value?.id).filter(Boolean);
      
      // Conversão segura de valores numéricos
      const nivelDe = formState.nivelDe && formState.nivelDe !== '' ? parseFloat(formState.nivelDe) : undefined;
      const nivelAte = formState.nivelAte && formState.nivelAte !== '' ? parseFloat(formState.nivelAte) : undefined;
      
      // Verificar se conversão foi bem-sucedida
      if (formState.nivelDe !== '' && isNaN(nivelDe)) {

        return;
      }
      if (formState.nivelAte !== '' && isNaN(nivelAte)) {

        return;
      }

      const payload = {
        // RPI é opcional - só incluir se preenchido
        ...(formState.rpi && formState.rpi.trim() !== '' && { revistaRPI: formState.rpi.trim() }),
        marca: formState.marca && formState.marca.trim() !== '' ? formState.marca.trim() : undefined,
        tipo: formState.tipo && formState.tipo !== '' ? formState.tipo : undefined,
        nivelDe,
        nivelAte,
        orderBy: formState.ordem,
        processo: formState.processo && formState.processo.trim() !== '' ? formState.processo.trim() : undefined,
        envolvido: (() => {
          const ids = envolvidosBusca.map(e => e.value?.id).filter(Boolean);
          if (ids.length === 0) return undefined;
          if (ids.length === 1) return String(ids[0]); 
          return ids.map(String); 
        })(),
        responsavel: (() => {
          const ids = responsaveisBusca.map(e => e.value?.value).filter(Boolean);
          if (ids.length === 0) return undefined;
          if (ids.length === 1) return ids[0]; 
          return ids; 
        })(),
        termosExcluir: formState.radical && formState.radical.trim() !== '' ? formState.radical.trim() : undefined,
        exata: formState.exata ? 'true' : 'false',
        somentesSelecionados: formState.somentesSelecionados,
        page: pagination.page + 1,
        limit: pagination.perPage
      };      
      
      // Limpar propriedades undefined
      Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

      const response = await makeRequest("/colidencias/search", "POST", payload);

  if ((response.status === 200 || response.status === 201) && response.data) {
        let resultData = [];
        
        // Verificar se a resposta tem a estrutura esperada
        if (response.data.data && Array.isArray(response.data.data)) {

          resultData = response.data.data;
          setResults(resultData);
          if (response.data.pagination) {
            setPagination(prev => ({
              ...prev,
              count: response.data.pagination.total || 0
            }));
          }
          setErrorMsg("");
        } else if (Array.isArray(response.data)) {

          resultData = response.data;
          setResults(resultData);
          setErrorMsg("");
        } else {

          setResults([]);
        }
        
        // Sincronizar seleções vindas do banco com estado local
        if (resultData.length > 0) {
          const selectedFromDatabase = new Set();
          
          resultData.forEach(item => {
            if (item.selecionada === true) {
              const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
              selectedFromDatabase.add(itemId);
            }
          });
          
          if (selectedFromDatabase.size > 0) {

            // Atualizar estados locais com seleções do banco
            setSelectedColidencias(prev => {
              const newSet = new Set(prev);
              selectedFromDatabase.forEach(id => newSet.add(id));
              return newSet;
            });
            
            setConfirmedSelections(prev => {
              const newSet = new Set(prev);
              selectedFromDatabase.forEach(id => newSet.add(id));
              return newSet;
            });
          }
        }
      } else {

        setResults([]);
        setErrorMsg(mapApiError(response));
      }
    } catch (error) {

      setResults([]);
      setErrorMsg(mapApiError(error));
    }
  };  const handleReset = () => {
    // Resetar todos os campos incluindo seleções
    setFormState(initialFormState);
    setResults([]);
    setSelectedColidencias(new Set());
    setUpdatingItems(new Set());
    setPagination({
      page: 0,
      perPage: 30,
      count: 0,
      sortBy: "marca_nivel",
      sortOrder: "desc"
    });
    
    // Resetar também os campos de busca múltipla
    setEnvolvidosBusca([{ id: '', value: null }]);
    setResponsaveisBusca([{ id: '', value: null }]);
    setRpiInput("");
  };

  // Função para selecionar/deselecionar uma colidência (apenas estado local)
  const handleSelectColidencia = (colidenciaId) => {
    setSelectedColidencias(prev => {
      const newSet = new Set(prev);
      if (newSet.has(colidenciaId)) {
        newSet.delete(colidenciaId);
      } else {
        newSet.add(colidenciaId);
      }
      return newSet;
    });

    // Atualizar seleções pendentes
    setPendingSelections(prev => {
      const newSet = new Set(prev);
      const wasConfirmed = confirmedSelections.has(colidenciaId);
      const isNowSelected = !selectedColidencias.has(colidenciaId);
      
      if (wasConfirmed && !isNowSelected) {
        // Era confirmada e agora foi desmarcada - adicionar como pendente
        newSet.add(colidenciaId);
      } else if (!wasConfirmed && isNowSelected) {
        // Não era confirmada e agora foi marcada - adicionar como pendente
        newSet.add(colidenciaId);
      } else if (wasConfirmed && isNowSelected) {
        // Era confirmada e continua marcada - remover das pendentes
        newSet.delete(colidenciaId);
      } else {
        // Não era confirmada e continua desmarcada - remover das pendentes
        newSet.delete(colidenciaId);
      }
      
      return newSet;
    });
  };

  // Função para selecionar/deselecionar todas as colidências visíveis (apenas estado local)
  const handleSelectAll = () => {
    const allCurrentIds = results.map(item => `${item.processo_base.numero}-${item.processo_colidente.numero}`);
    const allSelected = allCurrentIds.every(id => selectedColidencias.has(id));
    const newSelected = !allSelected;
    
    setSelectedColidencias(prev => {
      const newSet = new Set(prev);
      if (newSelected) {
        allCurrentIds.forEach(id => newSet.add(id));
      } else {
        allCurrentIds.forEach(id => newSet.delete(id));
      }
      return newSet;
    });

    // Atualizar seleções pendentes para todos os itens
    setPendingSelections(prev => {
      const newSet = new Set(prev);
      allCurrentIds.forEach(id => {
        const wasConfirmed = confirmedSelections.has(id);
        const isNowSelected = newSelected;
        
        if (wasConfirmed && !isNowSelected) {
          newSet.add(id);
        } else if (!wasConfirmed && isNowSelected) {
          newSet.add(id);
        } else {
          newSet.delete(id);
        }
      });
      return newSet;
    });
  };

  // Função para atualizar colidências selecionadas no INPI
  const handleUpdateSelected = async () => {
    if (selectedColidencias.size === 0) {
      setSnackbar({ open: true, severity: 'info', message: 'Selecione pelo menos uma colidência para atualizar.' });
      return;
    }

    setIsUpdating(true);
    setUpdatingItems(new Set(selectedColidencias));
    
    try {
      const selectedIds = results
        .filter(item => selectedColidencias.has(`${item.processo_base.numero}-${item.processo_colidente.numero}`))
        .map(item => item.id);

      const response = await makeRequest('/colidencias/atualizar-inpi', 'POST', {
        colidenciaIds: selectedIds
      });

    if (response && response.data) {
        const { processados, atualizados, erros } = response.data;
        
        if (erros.length > 0) {

      setSnackbar({ open: true, severity: 'warning', message: `Atualização concluída com ${erros.length} erro(s). ${atualizados}/${processados} colidências atualizadas.` });
        } else {
      setSnackbar({ open: true, severity: 'success', message: `${atualizados} colidência(s) atualizada(s) com sucesso no INPI!` });
        }
        
        // Limpar seleções após sucesso
        setSelectedColidencias(new Set());
        
        // Opcional: recarregar dados para mostrar timestamps atualizados
        // handleSubmit();
      } else {
        setSnackbar({ open: true, severity: 'error', message: 'Erro: resposta inválida do servidor.' });
      }
    } catch (error) {

      setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
    } finally {
      setIsUpdating(false);
      setUpdatingItems(new Set());
    }
  };  

  // Função para confirmar as seleções e enviar para o backend
  const handleConfirmarSelecoes = async () => {
    if (pendingSelections.size === 0) {
      setSnackbar({ open: true, severity: 'info', message: 'Nenhuma alteração pendente para confirmar.' });
      return;
    }

    const confirmacao = window.confirm(
      `Deseja confirmar ${pendingSelections.size} alteração(ões) pendente(s)?\n\nEsta ação irá salvar as seleções no sistema.`
    );

    if (!confirmacao) return;

    try {
      setLoadingConfirmacao(true);
      
      // Separar as seleções em ações: selecionar e deselecionar
      const toSelect = [];
      const toDeselect = [];
      
      Array.from(pendingSelections).forEach(colidenciaId => {
        const isCurrentlySelected = selectedColidencias.has(colidenciaId);
        const wasConfirmed = confirmedSelections.has(colidenciaId);
        
        // Buscar o ID real da colidência dos dados
        const colidencia = results.find(item => 
          `${item.processo_base.numero}-${item.processo_colidente.numero}` === colidenciaId
        );
        
        if (colidencia) {
          if (isCurrentlySelected && !wasConfirmed) {
            // Nova seleção
            toSelect.push(colidencia.id);
          } else if (!isCurrentlySelected && wasConfirmed) {
            // Deseleção
            toDeselect.push(colidencia.id);
          }
        }
      });

      // Enviar as seleções para o backend
      const promises = [];
      
      if (toSelect.length > 0) {
        promises.push(
          makeRequest("/colidencias/selecionar", "POST", {
            colidenciaIds: toSelect,
            selecionada: true
          })
        );
      }
      
      if (toDeselect.length > 0) {
        promises.push(
          makeRequest("/colidencias/selecionar", "POST", {
            colidenciaIds: toDeselect,
            selecionada: false
          })
        );
      }

      const responses = await Promise.all(promises);
      
      // Verificar se todas as requisições foram bem-sucedidas
      const allSuccess = responses.every(response => 
        response.status === 200 || response.status === 201
      );

  if (allSuccess) {
        // Atualizar as seleções confirmadas
        setConfirmedSelections(new Set(selectedColidencias));
        
        // Limpar as seleções pendentes
        setPendingSelections(new Set());

        setSnackbar({ open: true, severity: 'success', message: `Seleções confirmadas! ${toSelect.length} selecionadas, ${toDeselect.length} desmarcadas.` });
      } else {

        setSnackbar({ open: true, severity: 'error', message: 'Erro ao confirmar algumas seleções.' });
      }
    } catch (error) {

      setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
    } finally {
      setLoadingConfirmacao(false);
    }
  };

  // Função para limpar todas as seleções
  const handleClearAllSelections = async () => {
    try {
      const response = await makeRequest("/colidencias/limpar-selecoes", "POST", {});
      
      if (response.status === 200) {
        setSelectedColidencias(new Set());

      } else {

        setSnackbar({ open: true, severity: 'error', message: mapApiError(response) });
      }
    } catch (error) {

      setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
    }
  };

  // Função para selecionar/deselecionar grupo de RPI (apenas estado local)
  const handleSelectGroup = (groupItems) => {
    const groupIds = groupItems.map(item => `${item.processo_base.numero}-${item.processo_colidente.numero}`);
    const allGroupSelected = groupIds.every(id => selectedColidencias.has(id));
    const newSelected = !allGroupSelected;
    
    setSelectedColidencias(prev => {
      const newSet = new Set(prev);
      if (newSelected) {
        groupIds.forEach(id => newSet.add(id));
      } else {
        groupIds.forEach(id => newSet.delete(id));
      }
      return newSet;
    });

    // Atualizar seleções pendentes para o grupo
    setPendingSelections(prev => {
      const newSet = new Set(prev);
      groupIds.forEach(id => {
        const wasConfirmed = confirmedSelections.has(id);
        const isNowSelected = newSelected;
        
        if (wasConfirmed && !isNowSelected) {
          newSet.add(id);
        } else if (!wasConfirmed && isNowSelected) {
          newSet.add(id);
        } else {
          newSet.delete(id);
        }
      });
      return newSet;
    });
  };

  // Função para cancelar as alterações pendentes
  const handleCancelarAlteracoes = () => {
    // Restaurar o estado para as seleções confirmadas
    setSelectedColidencias(new Set(confirmedSelections));
    
    // Limpar as seleções pendentes
    setPendingSelections(new Set());

  };

  const handleProcessClick = async (processNumber) => {
    if (!processNumber) return;
    
    try {

      const response = await makeRequest(`/processos-revistas-rpi?num_processo=${encodeURIComponent(processNumber)}`, "GET");
      
      if (response.status === 200 && response.data) {
        let processo = null;
        
        if (response.data.processos && Array.isArray(response.data.processos) && response.data.processos.length > 0) {
          processo = response.data.processos[0];
        } else if (Array.isArray(response.data) && response.data.length > 0) {
          processo = response.data[0];
        }
        
        if (processo && processo.id) {

          navigateToProcesso(processo.id);
        } else {

          setSnackbar({ open: true, severity: 'info', message: 'Processo não encontrado.' });
        }
      } else {

        setSnackbar({ open: true, severity: 'info', message: 'Processo não encontrado.' });
      }
    } catch (error) {

      setSnackbar({ open: true, severity: 'error', message: mapApiError(error) });
    }
  };

  const mockData = [
    {
      elemento: "NETSHARING",
      marca: "LET'S HANG OUT",
      nivel: "70%", 
      tipo: "APR"
    },
    {
      elemento: "#NEXUSNETSHARING",
      marca: "RING",
      nivel: "60%",
      tipo: "SUF"  
    },
    {
      elemento: "#NEXUSNETSHARING",
      marca: "NEXUS FERRAMENTAS DE CONFIANÇA",
      nivel: "26.67%",
      tipo: "PRE"
    },
    {
      elemento: "RESULTADOS",
      marca: "LIBERUM SCIENCE DATA SCIENCE FOR BEST RESULTS",
      nivel: "60%",
      tipo: "RAD"
    }
  ];
  const getColorStyle = (nivel) => {
    const numericPercentage = parseFloat(nivel);
    if (numericPercentage >= 70) {
      return {
        backgroundColor: '#ffebee',
        color: '#d32f2f'
      };
    }
    if (numericPercentage >= 60) {
      return {
        backgroundColor: '#fff3e0',
        color: '#ed6c02'
      };
    }
    return {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32'
    };
  };

  // Função para encontrar classes em comum e destacá-las
  const formatClassesWithCommon = (classesString, otherClassesString) => {
    if (!classesString || !otherClassesString) {
      return classesString || 'N/A';
    }
    
    const classes = classesString.split(', ').map(c => c.trim());
    const otherClasses = otherClassesString.split(', ').map(c => c.trim());
    const commonClasses = classes.filter(c => otherClasses.includes(c));
    
    if (commonClasses.length === 0) {
      return classesString;
    }
    
    // Retornar string formatada destacando classes comuns
    return classes.map(classe => {
      if (commonClasses.includes(classe)) {
        return `${classe} ✓`;
      }
      return classe;
    }).join(', ');
  };const groupedResults = useMemo(() => {
    if (!Array.isArray(results) || results.length === 0) {
      return {};
    }
    
    const groups = {};
    
    results.forEach(item => {
      const processo_base = item.processo_base || {};
      const processo_colidente = item.processo_colidente || {};
      const revista_rpi = item.revista_rpi || {};
      
      // Determinar qual grupo usar baseado na RPI real
      let groupKey;
      if (formState.rpi && formState.rpi.trim() !== '') {
        // Se há filtro de RPI específico, usar apenas essa RPI
        groupKey = `RPI ${formState.rpi}`;
      } else {
        // Se busca geral, agrupar por RPI real de cada colidência
        groupKey = revista_rpi.numero ? `RPI ${revista_rpi.numero}` : 'RPI Não Identificada';
      }
      
      // Criar grupo se não existir
      if (!groups[groupKey]) {
        groups[groupKey] = [];
      }
      
      groups[groupKey].push({
        processo_base: {
          numero: processo_base.numero || '',
          marca: processo_base.marca?.[0]?.nome || '',
          procurador: processo_base.procurador || '',
          data_deposito: processo_base.data_deposito,
          natureza: processo_base.natureza,
          situacao: processo_base.situacao,
          classes: processo_base.classes_nice ? processo_base.classes_nice.map(c => c.codigo).join(', ') : ''
        },
        processo_colidente: {
          numero: processo_colidente.numero || '',
          marca: processo_colidente.marca?.[0]?.nome || '',
          procurador: processo_colidente.procurador || '',
          data_deposito: processo_colidente.data_deposito,
          natureza: processo_colidente.natureza,
          situacao: processo_colidente.situacao,
          classes: processo_colidente.classes_nice ? processo_colidente.classes_nice.map(c => c.codigo).join(', ') : ''
        },
        nivel: item.nivel_similaridade ? `${(item.nivel_similaridade * 100).toFixed(2)}%` : '0%',
        tipo: item.tipo_colidencia || '',
        nivel_raw: item.nivel_similaridade || 0,
        rpi_origem: revista_rpi.numero || 'N/A' // Adicionar RPI de origem
      });
    });

    return groups;
  }, [results, formState.rpi]);

  const sortedRPIs = useMemo(() => {
    return Object.keys(groupedResults)
      .sort((a, b) => {
        // Extrair números das RPIs para ordenação correta
        const aNum = a.match(/\d+/);
        const bNum = b.match(/\d+/);
        
        if (aNum && bNum) {
          return parseInt(bNum[0]) - parseInt(aNum[0]); // Ordem decrescente
        }
        
        // Fallback para ordenação alfabética
        return b.localeCompare(a);
      });
  }, [groupedResults]);

  return (
    <JumboContentLayout>
      {errorMsg && (<Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>)}
      <Typography 
        component="h1" 
        sx={{ 
          fontSize: '28px',
          fontWeight: 500,
          color: '#313541',
          mb: 3 
        }}
      >
        Colidências de Marcas
      </Typography>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Ordem</InputLabel>
                <Select
                  value={formState.ordem}
                  label="Ordem"
                  name="ordem"
                  onChange={handleInputChange}
                >                  <MenuItem value="marca_nivel">Marca, Nível</MenuItem>
                  <MenuItem value="nivel">Nível</MenuItem>
                  <MenuItem value="tipo_nivel">Tipo, Nível</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              {/* Barra de busca/autocomplete para RPI, busca só ao Enter */}
              <Autocomplete
                freeSolo
                options={rpiOptions}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  return option.numero || '';
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <div>
                      <div>{option.numero}</div>
                      {option.data_lancamento && (
                        <div style={{ fontSize: '0.8em', color: 'gray' }}>
                          {new Date(option.data_lancamento).toLocaleDateString('pt-BR')}
                        </div>
                      )}
                    </div>
                  </li>
                )}
                inputValue={rpiInput}
                onInputChange={(_, newInputValue) => setRpiInput(newInputValue)}
                value={rpiOptions.find(opt => opt.numero === formState.rpi) || null}
                onChange={(_, newValue) => {
                  const rpiNumber = typeof newValue === 'string' ? newValue : newValue?.numero || '';
                  setFormState(prev => ({ ...prev, rpi: rpiNumber }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Buscar RPI (opcional)"
                    fullWidth
                    size="small"
                    onKeyDown={handleRpiInputKeyDown}
                    helperText="Deixe vazio para buscar em todas as RPIs"
                  />
                )}
                disabled={loading}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select
                  value={formState.tipo}
                  label="Tipo"
                  name="tipo"
                  onChange={handleInputChange}
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  {TIPOS_COLIDENCIA.map((tipo) => (
                    <MenuItem key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Processo"
                value={formState.processo}
                onChange={handleInputChange}
                name="processo"
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Envolvido(s):</Typography>
                {envolvidosBusca.map((item, idx) => (
                  <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
                    <Autocomplete
                      options={envolvidosOptions}
                      getOptionLabel={option => option.nome_identificacao || ''}
                      value={item.value}
                      onChange={(_, newValue) => handleChangeEnvolvido(idx, newValue)}
                      renderInput={params => (
                        <TextField {...params} label={`Envolvido ${idx + 1}`} size="small" fullWidth />
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      sx={{ flex: 1 }}
                    />
                    {envolvidosBusca.length > 1 && (
                      <Button color="error" size="small" onClick={() => handleRemoveEnvolvido(idx)} sx={{ ml: 1 }}>REMOVER</Button>
                    )}
                  </Box>
                ))}
                <Button size="small" onClick={handleAddEnvolvido}>+ ADICIONAR ENVOLVIDO</Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Responsável(is):</Typography>
                {responsaveisBusca.map((item, idx) => (                  <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
                    <Autocomplete
                      options={responsaveisOptions}
                      getOptionLabel={option => option.label || option.nome || ''}
                      value={item.value}
                      onChange={(_, newValue) => handleChangeResponsavel(idx, newValue)}
                      renderInput={params => (
                        <TextField {...params} label={`Responsável ${idx + 1}`} size="small" fullWidth />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      sx={{ flex: 1 }}
                    />
                    {responsaveisBusca.length > 1 && (
                      <Button color="error" size="small" onClick={() => handleRemoveResponsavel(idx)} sx={{ ml: 1 }}>REMOVER</Button>
                    )}
                  </Box>
                ))}
                <Button size="small" onClick={handleAddResponsavel}>+ ADICIONAR RESPONSÁVEL</Button>
              </Box>
            </Grid>

            {/* Campos de filtro avançado movidos para cima do botão */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Nível de</InputLabel>
                <Select
                  value={formState.nivelDe}
                  label="Nível de"
                  name="nivelDe"
                  onChange={handleInputChange}
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  {niveisOptions.map((nivel) => (
                    <MenuItem key={nivel.value} value={nivel.value}>
                      {nivel.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Até</InputLabel>
                <Select
                  value={formState.nivelAte}
                  label="Até"
                  name="nivelAte"
                  onChange={handleInputChange}
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  {niveisOptions.map((nivel) => (
                    <MenuItem key={nivel.value} value={nivel.value}>
                      {nivel.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Marca</InputLabel>
                <TextField
                  fullWidth
                  size="small"
                  label="Marca"
                  value={formState.marca}
                  onChange={handleInputChange}
                  name="marca"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="Excluir radical"
                value={formState.radical}
                onChange={handleInputChange}
                name="radical"
                placeholder="termo1, termo2, termo3"
                helperText="Digite radicais para excluir dos resultados"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formState.exata}
                    size="small"
                    onChange={handleInputChange}
                    name="exata"
                  />
                }
                label="Exata"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formState.somentesSelecionados}
                    size="small"
                    onChange={handleInputChange}
                    name="somentesSelecionados"
                  />
                }
                label="Somente Selecionados"
                sx={{ ml: 2 }}
              />
            </Grid>
            {/* Botões de ação */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Button 
                  variant="contained" 
                  size="small"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? 'Pesquisando...' : 'Pesquisar'}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleReset}
                  disabled={loading}
                >
                  Limpar
                </Button>
                
                {/* Botões de seleção e atualização */}
                {selectedColidencias.size > 0 && (
                  <>
                    <Typography 
                      variant="caption" 
                      color="primary"
                      sx={{ ml: 2, fontWeight: 'bold' }}
                    >
                      {selectedColidencias.size} selecionada(s)
                    </Typography>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleUpdateSelected}
                      disabled={isUpdating}
                      startIcon={isUpdating ? <AccessTime /> : <Refresh />}
                      sx={{ 
                        backgroundColor: '#4CAF50',
                        '&:hover': { backgroundColor: '#45a049' }
                      }}
                    >
                      {isUpdating ? 'Atualizando...' : 'Atualizar no INPI'}
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleClearAllSelections}
                      disabled={isUpdating}
                      color="warning"
                    >
                      Limpar Seleções
                    </Button>
                  </>
                )}
                <Typography 
                  variant="caption" 
                  color="text.secondary"
                  sx={{ ml: 1 }}
                >
                  {(() => {
                    // Verificar se há critérios de busca definidos
                    const hasFilters = formState.rpi || formState.marca || formState.processo || 
                                     formState.tipo || formState.nivelDe || formState.nivelAte ||
                                     formState.radical || envolvidosBusca.some(e => e.value?.id) ||
                                     responsaveisBusca.some(e => e.value?.value);
                    
                    if (!hasFilters) {
                      return 'Buscando todas as colidências';
                    } else if (formState.rpi) {
                      return `Buscando na RPI ${formState.rpi}`;
                    } else {
                      return 'Buscando em todas as RPIs com filtros aplicados';
                    }
                  })()}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Card de Confirmação de Seleções - Movido para cima */}
      {(selectedColidencias.size > 0 || pendingSelections.size > 0) && (
        <Card
          width="100%"
          sx={{
            textAlign: "left",
            padding: 2,
            marginTop: 2,
            border: pendingSelections.size > 0 ? '2px solid #ff9800' : '2px solid #4CAF50',
            backgroundColor: pendingSelections.size > 0 ? 'rgba(255, 152, 0, 0.05)' : 'rgba(76, 175, 80, 0.05)'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ 
              color: pendingSelections.size > 0 ? '#ff9800' : '#4CAF50', 
              fontWeight: 'bold' 
            }}>
              📋 Colidências Selecionadas ({selectedColidencias.size})
              {pendingSelections.size > 0 && (
                <Typography component="span" sx={{ color: '#ff9800', fontSize: '0.9em', ml: 1 }}>
                  • {pendingSelections.size} alteração(ões) pendente(s)
                </Typography>
              )}
            </Typography>
            
            <Box sx={{ display: 'flex', gap: 1 }}>
              {pendingSelections.size > 0 && (
                <Button
                  variant="outlined"
                  color="warning"
                  size="medium"
                  onClick={handleCancelarAlteracoes}
                  sx={{ 
                    minWidth: 100,
                    borderColor: '#ff9800',
                    color: '#ff9800',
                    '&:hover': {
                      borderColor: '#f57c00',
                      backgroundColor: 'rgba(255, 152, 0, 0.04)'
                    }
                  }}
                >
                  Cancelar
                </Button>
              )}
              
              <Button
                variant="contained"
                color={pendingSelections.size > 0 ? "warning" : "success"}
                size="medium"
                disabled={loadingConfirmacao || pendingSelections.size === 0}
                onClick={handleConfirmarSelecoes}
                startIcon={loadingConfirmacao ? <CircularProgress size={18} /> : null}
                sx={{ 
                  minWidth: 140,
                  backgroundColor: pendingSelections.size > 0 ? '#ff9800' : '#4CAF50',
                  '&:hover': {
                    backgroundColor: pendingSelections.size > 0 ? '#f57c00' : '#45a049'
                  },
                  '&:disabled': {
                    backgroundColor: '#ccc'
                  }
                }}
              >
                {loadingConfirmacao ? 'Confirmando...' : 
                 pendingSelections.size > 0 ? 'Confirmar Alterações' : 'Nenhuma Alteração'}
              </Button>
            </Box>
          </Box>
          
          {pendingSelections.size > 0 ? (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Você tem {pendingSelections.size} alteração(ões) pendente(s). 
              Clique em "Confirmar Alterações" para salvar no sistema ou "Cancelar" para reverter.
            </Alert>
          ) : (
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              Seleções confirmadas no sistema. Use o filtro "Somente Selecionados" para ver apenas estas colidências.
            </Typography>
          )}

          {/* Seção de ações quando há seleções confirmadas */}
          {selectedColidencias.size > 0 && pendingSelections.size === 0 && (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2, p: 2, backgroundColor: 'rgba(33, 150, 243, 0.05)', borderRadius: 1 }}>
              <Typography variant="body2" sx={{ color: '#1976D2', fontWeight: 'bold', flex: 1 }}>
                🔄 Ações para {selectedColidencias.size} colidência(s) confirmada(s):
              </Typography>
              
              <Button
                variant="contained"
                color="info"
                size="medium"
                disabled={isUpdating}
                onClick={handleUpdateSelected}
                startIcon={isUpdating ? <AccessTime /> : <Refresh />}
                sx={{ 
                  minWidth: 160,
                  backgroundColor: '#2196F3',
                  '&:hover': {
                    backgroundColor: '#1976D2'
                  },
                  '&:disabled': {
                    backgroundColor: '#ccc'
                  }
                }}
              >
                {isUpdating ? 'Atualizando...' : 'Atualizar no INPI'}
              </Button>

              <Button
                variant="outlined"
                size="medium"
                onClick={handleClearAllSelections}
                disabled={isUpdating}
                color="warning"
                sx={{
                  borderColor: '#ff9800',
                  color: '#ff9800',
                  '&:hover': {
                    borderColor: '#f57c00',
                    backgroundColor: 'rgba(255, 152, 0, 0.04)'
                  }
                }}
              >
                Limpar Todas
              </Button>
            </Box>
          )}
        </Card>
      )}

      {loading ? (
        <CircularProgress />
      ) : (
        sortedRPIs.map((revistaNum) => (
          <Box key={revistaNum} sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              {revistaNum}
              <Typography variant="body2" color="text.secondary">
                ({groupedResults[revistaNum].length} colidências)
              </Typography>
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={(() => {
                          const groupItems = groupedResults[revistaNum];
                          const selectedInGroup = groupItems.filter(item => {
                            const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                            return selectedColidencias.has(itemId);
                          }).length;
                          return selectedInGroup > 0 && selectedInGroup < groupItems.length;
                        })()}
                        checked={(() => {
                          const groupItems = groupedResults[revistaNum];
                          return groupItems.length > 0 && groupItems.every(item => {
                            const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                            return selectedColidencias.has(itemId);
                          });
                        })()}
                        onChange={() => {
                          const groupItems = groupedResults[revistaNum];
                          handleSelectGroup(groupItems);
                        }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>Processo Base</TableCell>
                    <TableCell>Marca Base</TableCell>
                    <TableCell>Classes Base</TableCell>
                    <TableCell>Processo Colidente</TableCell>
                    <TableCell>Marca Colidente</TableCell>
                    <TableCell>Classes Colidente</TableCell>
                    <TableCell align="center">Nível</TableCell>
                    <TableCell>Tipo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupedResults[revistaNum].map((item, index) => {
                    const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                    const isSelected = selectedColidencias.has(itemId);
                    const isPending = pendingSelections.has(itemId);
                    const isFromDatabase = item.selecionada === true; // Vem do banco como selecionada
                    const isConfirmed = (isSelected && !isPending) || isFromDatabase;
                    
                    return (
                      <TableRow 
                        key={index}
                        sx={{
                          backgroundColor: isConfirmed 
                            ? 'rgba(76, 175, 80, 0.08)' 
                            : isPending 
                              ? 'rgba(255, 152, 0, 0.05)' 
                              : 'transparent',
                          '&:hover': {
                            backgroundColor: isConfirmed 
                              ? 'rgba(76, 175, 80, 0.12)' 
                              : isPending 
                                ? 'rgba(255, 152, 0, 0.08)' 
                                : 'rgba(0, 0, 0, 0.04)'
                          },
                          borderLeft: isConfirmed 
                            ? '4px solid #4CAF50' 
                            : isPending 
                              ? '4px solid #ff9800' 
                              : '4px solid transparent'
                        }}
                      >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={(() => {
                            const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                            return selectedColidencias.has(itemId) || item.selecionada === true;
                          })()}
                          onChange={() => {
                            const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                            handleSelectColidencia(itemId);
                          }}
                          size="small"
                          disabled={(() => {
                            const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                            return updatingItems.has(itemId);
                          })()}
                        />
                        {(() => {
                          const itemId = `${item.processo_base.numero}-${item.processo_colidente.numero}`;
                          
                          if (pendingSelections.has(itemId)) {
                            return (
                              <Typography 
                                variant="caption"
                                sx={{ 
                                  color: '#ff9800',
                                  ml: 0.5,
                                  fontSize: '0.7em',
                                  fontWeight: 'bold'
                                }}
                              >
                                PENDENTE
                              </Typography>
                            );
                          }
                          
                          if (updatingItems.has(itemId)) {
                            return (
                              <AccessTime 
                                sx={{ 
                                  fontSize: 16, 
                                  color: '#ff9800', 
                                  ml: 0.5,
                                  animation: 'spin 1s linear infinite',
                                  '@keyframes spin': {
                                    '0%': {
                                      transform: 'rotate(0deg)',
                                    },
                                    '100%': {
                                      transform: 'rotate(360deg)',
                                    },
                                  },
                                }} 
                              />
                            );
                          }
                          
                          // Mostrar indicador para itens confirmados como selecionados (local ou banco)
                          if ((selectedColidencias.has(itemId) && !pendingSelections.has(itemId)) || item.selecionada === true) {
                            return (
                              <Typography 
                                variant="caption"
                                sx={{ 
                                  color: '#4CAF50',
                                  ml: 0.5,
                                  fontSize: '0.8em',
                                  fontWeight: 'bold',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.3
                                }}
                              >
                                ✓ SELECIONADO
                              </Typography>
                            );
                          }
                          
                          return null;
                        })()}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={
                          <div>
                            <div>Procurador: {item.processo_base.procurador}</div>
                            <div>Data depósito: {new Date(item.processo_base.data_deposito).toLocaleDateString()}</div>
                            <div>Natureza: {item.processo_base.natureza}</div>
                            <div>Situação: {item.processo_base.situacao}</div>
                          </div>
                        }>                          <span 
                            style={{ 
                              cursor: 'pointer',
                              color: '#0d47a1',
                              textDecoration: 'underline',
                              fontWeight: 'bold'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleProcessClick(item.processo_base.numero);
                            }}
                            onMouseOver={(e) => {
                              e.target.style.color = '#1565c0';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.color = '#0d47a1';
                            }}
                          >
                            {item.processo_base.numero}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>{item.processo_base.marca}</TableCell>
                      <TableCell>
                        <Tooltip title={`Classes: ${item.processo_base.classes || 'Nenhuma'}${
                          item.processo_base.classes && item.processo_colidente.classes ? 
                          `\nClasses em comum: ${item.processo_base.classes.split(', ').filter(c => 
                            item.processo_colidente.classes.split(', ').includes(c.trim())
                          ).join(', ') || 'Nenhuma'}` : ''
                        }`}>
                          <Typography variant="body2" color="text.secondary" sx={{ 
                            maxWidth: '120px', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {formatClassesWithCommon(item.processo_base.classes, item.processo_colidente.classes)}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={
                          <div>
                            <div>Procurador: {item.processo_colidente.procurador}</div>
                            <div>Data depósito: {new Date(item.processo_colidente.data_deposito).toLocaleDateString()}</div>
                            <div>Natureza: {item.processo_colidente.natureza}</div>
                            <div>Situação: {item.processo_colidente.situacao}</div>
                          </div>
                        }>                          <span 
                            style={{ 
                              cursor: 'pointer',
                              color: '#0d47a1',
                              textDecoration: 'underline',
                              fontWeight: 'bold'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleProcessClick(item.processo_colidente.numero);
                            }}
                            onMouseOver={(e) => {
                              e.target.style.color = '#1565c0';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.color = '#0d47a1';
                            }}
                          >
                            {item.processo_colidente.numero}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>{item.processo_colidente.marca}</TableCell>
                      <TableCell>
                        <Tooltip title={`Classes: ${item.processo_colidente.classes || 'Nenhuma'}${
                          item.processo_base.classes && item.processo_colidente.classes ? 
                          `\nClasses em comum: ${item.processo_colidente.classes.split(', ').filter(c => 
                            item.processo_base.classes.split(', ').includes(c.trim())
                          ).join(', ') || 'Nenhuma'}` : ''
                        }`}>
                          <Typography variant="body2" color="text.secondary" sx={{ 
                            maxWidth: '120px', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {formatClassesWithCommon(item.processo_colidente.classes, item.processo_base.classes)}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          component="span"
                          sx={{
                            ...getColorStyle(item.nivel),
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            display: 'inline-block'
                          }}
                        >
                          {item.nivel}
                        </Box>
                      </TableCell>
                      <TableCell>{item.tipo}</TableCell>
                    </TableRow>
                    );
                  })}
                </TableBody>              </Table>
            </TableContainer>
          </Box>
        ))
      )}

      {results.length > 0 && (
        <Card
          width="100%"
          sx={{
            textAlign: "center",
            padding: 2,
            marginTop: 2,
          }}
        >
          {/* Alerta de seleção */}
          {selectedColidencias.size > 0 && (
            <Alert 
              severity="info" 
              sx={{ mb: 2 }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => setSelectedColidencias(new Set())}
                >
                  Limpar Seleção
                </Button>
              }
            >
              {selectedColidencias.size} colidência(s) selecionada(s) para atualização no INPI
            </Alert>
          )}
          
          {/* Mostrar aviso sobre paginação quando há múltiplos grupos */}
          {Object.keys(groupedResults).length > 1 && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              ℹ️ Quando há múltiplas RPIs, a paginação mostra os primeiros {pagination.perPage} resultados de cada página, 
              distribuídos entre as RPIs encontradas.
            </Typography>
          )}
          
          <Grid container width="100%" spacing={2}>
            <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" }}>
              <Typography fontWeight={600}>Página: {pagination.page + 1}</Typography>
              <Typography variant="subtitle2">Total de registros encontrados: {pagination.count}</Typography>
              <Pagination
                count={Math.ceil(pagination.count / pagination.perPage)}
                page={pagination.page + 1}
                onChange={(event, value) => {
                  setPagination(prev => ({ ...prev, page: value - 1 }));
                  setShouldSearch(true);
                }}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={2} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" }}>
              <Typography fontWeight={600}>Itens por página</Typography>
              <Select
                value={pagination.perPage}
                onChange={(event) => {
                  const value = Number(event.target.value);
                  setPagination(prev => ({ ...prev, perPage: value, page: 0 }));
                  setShouldSearch(true);
                }}
                fullWidth
                disabled={loading}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={3} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" }}>
              <Typography fontWeight={600}>Ordenar por:</Typography>
              <Select
                value={formState.ordem}
                onChange={(event) => {
                  const value = event.target.value;
                  setFormState(prev => ({ ...prev, ordem: value }));
                  setPagination(prev => ({ ...prev, sortBy: value }));
                  setShouldSearch(true);
                }}
                fullWidth
              >
                <MenuItem value="marca_nivel">Marca e Nível</MenuItem>
                <MenuItem value="nivel">Nível</MenuItem>
                <MenuItem value="tipo_nivel">Tipo e Nível</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Card>
      )}
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar(s => ({ ...s, open: false }))}>
        <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </JumboContentLayout>
  );
};

export default PatentesColidencias;
